/**
 * Phase 1: keep storefront web components on English / US market context.
 */
const STORE_LANGUAGE = 'EN';
const STORE_COUNTRY = 'US';

function applyEnglishStoreContext() {
  document.querySelectorAll('shopify-store').forEach((store) => {
    if (store.getAttribute('language') !== STORE_LANGUAGE) {
      store.setAttribute('language', STORE_LANGUAGE);
    }
    if (store.getAttribute('country') !== STORE_COUNTRY) {
      store.setAttribute('country', STORE_COUNTRY);
    }
  });
}

applyEnglishStoreContext();
document.addEventListener('DOMContentLoaded', applyEnglishStoreContext);
new MutationObserver(applyEnglishStoreContext).observe(document.documentElement, {
  childList: true,
  subtree: true,
});
